import { useEffect, useRef } from 'react';

export const usePageshow = (callback: () => void) => {
    useEffect(() => {
        window.addEventListener('pageshow', callback);
        return () => {
            window.removeEventListener('pageshow', callback);
        };
    }, []);
};

export const usePageVisible = (callback: (status: 'visible' | 'hidden') => void) => {
    const cb = useRef(callback);
    cb.current = callback;

    useEffect(() => {
        const onPageShow = () => {
            cb.current('visible');
        };

        const onPageHide = () => {
            cb.current('hidden');
        };

        const onVisibilityChange = () => {
            cb.current(document.visibilityState);
        };

        window.addEventListener('pageshow', onPageShow);
        window.addEventListener('pagehide', onPageHide);
        window.addEventListener('beforeunload', onPageHide);
        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            window.removeEventListener('pageshow', onPageShow);
            window.removeEventListener('pagehide', onPageHide);
            window.removeEventListener('beforeunload', onPageHide);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
};
